import { TrackingSource } from './TrackingRequest';

// Which host served the widget: one of ours in production, a non-production one,
// or — for the code snippet — the partner's own page. This is a build/host
// classification; how the widget is embedded is `embedMode` (see embedPage.ts).
//
// Classified on the hostname only. It used to match the full URL, and the
// partner's `url=` parameter carries listing paths and vehicle names in it:
// every "demonstrator" and every "quattro" on a production dealer site was
// recorded as a test session.
const OUR_HOST = /vroom|youx|(^|\.)amplifyapp\.com$/i;
const NON_PRODUCTION_HOST = /demo|dev|uat/i;
const LOCAL_HOST = /^(localhost|127\.0\.0\.1|\[::1\])$/i;

export function classifySource(hostname: string | null | undefined): TrackingSource {
    const host = (hostname ?? '').toLowerCase();

    if (LOCAL_HOST.test(host)) return 'test';
    if (!OUR_HOST.test(host)) return 'codesnippet';
    if (NON_PRODUCTION_HOST.test(host)) return 'test';
    return 'iframe';
}

export function getSource(): TrackingSource {
    try {
        return classifySource(window.location.hostname);
    } catch (error) {
        return 'iframe';
    }
}
